import { render } from "./AccountPreview.vue?vue&type=template&id=013b3ebf&scoped=true"
import script from "./AccountPreview.vue?vue&type=script&lang=js"
export * from "./AccountPreview.vue?vue&type=script&lang=js"

import "./AccountPreview.vue?vue&type=style&index=0&id=013b3ebf&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b3ebf"]])

export default __exports__